import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { LoginParams } from "core/http/service/auth/paramsTypes";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: null;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const resetQrSlice = createSlice({
  name: "resetQr",
  initialState,
  reducers: {
    resetQrStart: (state, _action: PayloadAction<LoginParams>) => {
      state.status = ReduxStateType.LOADING;
    },
    resetQrSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    resetQrFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDataQr: () => {
      return { ...initialState };
    },
  },
});

export const { resetQrStart, resetQrSuccess, resetQrFailed, resetDataQr } =
  resetQrSlice.actions;

export default resetQrSlice.reducer;
